var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Template"},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v("预赛视频作品要求")]),_c('div',{staticClass:"span"}),_c('div',{staticClass:"boxcontent"},[_c('workTemplate')],1)]),_c('footerCard',{staticClass:"iosFooter"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }